import {
  useFanGroupStore,
  useFetchLook,
  getSlugFromUrl,
} from '@seaters/data-access';
import { primaryColor, secondaryColor } from '@seaters/ui';
import Color from 'color';
import { hexToRgb } from '@seaters/ui';
import { routes } from '@seaters/constants';

export const useFanGroupPrimaryColor = () => {
  // Get fan group primary color
  const slug = getSlugFromUrl();
  const { data: lookData } = useFetchLook(slug ?? '');

  const { fanGroup: storedFanGroup } = useFanGroupStore();
  const isAdminRoute =
    typeof window !== 'undefined' &&
    window.location.pathname.includes(`/${routes.admin}`);

  const fgColorToUse = isAdminRoute
    ? secondaryColor
    : slug
    ? lookData?.color
    : storedFanGroup?.color1;

  const primaryCustomColor = fgColorToUse
    ? Color(hexToRgb(`${fgColorToUse}`) ?? 'rgb(0, 0, 0)')
    : Color(hexToRgb(primaryColor) ?? 'rgb(0, 0, 0)');

  return {
    primaryColor: primaryCustomColor.hex(),
    primaryColorObject: primaryCustomColor,
    isCustomColor: !!fgColorToUse,
  };
};
